<div class="page-not-found">
  <div class="not-found__image"></div>
  <div class="not-found__message">
    <h1>{{ "NOT_FOUND.LOST" | translate }}</h1>
    <h2>{{ "NOT_FOUND.PAGE_NOT_FOUND" | translate }}</h2>
    <div class="not-found__actions">
      <a class="button button--primary" routerLink="/">
        {{ "NOT_FOUND.GO_TO_DASHBOARD" | translate }}
      </a>
    </div>
  </div>
</div>
